export const Logo = () => (
  <>
    <circle cx="12" cy="12" r="10" fill="#2E5CFF" />
    <path
      d="M16.3781 17.4618C16.3781 18.0145 16.3781 18.2909 16.1973 18.4279C16.0166 18.5649 15.7505 18.4902 15.2183 18.3409L6.66637 15.9411C6.34574 15.8512 6.18539 15.8062 6.0927 15.6839C6 15.5616 6 15.395 6 15.062V9.43797C6 9.10496 6 8.93844 6.0927 8.81613C6.18539 8.69383 6.34574 8.64883 6.66637 8.55887L15.2183 6.15906C15.7505 6.00975 16.0166 5.93508 16.1973 6.07209C16.3781 6.2091 16.3781 6.48547 16.3781 7.0382V17.4618ZM8.13281 15.1587L15.2138 17.146V13.1717L8.13281 15.1587ZM7.16414 14.2368L14.2438 12.25L7.16414 10.2632V14.2368ZM8.13273 9.34129L15.2138 11.3284V7.35402L8.13273 9.34129Z"
      fill="white"
    />
  </>
);
